import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../../store"
import OldUIContext from "../../../olduicontext"

import RecoverPasswordPage from "./components/RecoverPasswordPage"
import { IOldUIContext } from "../../../global"

function init(store: AppStore, oldUIContext: IOldUIContext): void {
    const element = document.getElementById("newui-recover-password")

    if (!element) {
        return // we're not on the recover password page, no need to init the recover password sub app
    }

    const root = createRoot(element)
    root.render(
        <Provider store={store}>
            <OldUIContext.Provider value={oldUIContext}>
                <RecoverPasswordPage />
            </OldUIContext.Provider>
        </Provider>,
    )
}

export default init
